import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ErrorFilledSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "3 3 26 26",
  color = "#236998",
  ...rest
}) => {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" {...rest}>
      <path
        d="M28.4137 10.0288L21.9713 3.58625C21.5951 3.21232 21.0867 3.00169 20.5562 3H11.4438C10.9133 3.00169 10.4049 3.21232 10.0288 3.58625L3.58625 10.0288C3.21232 10.4049 3.00169 10.9133 3 11.4438V20.5562C3.00169 21.0867 3.21232 21.5951 3.58625 21.9713L10.0288 28.4137C10.4049 28.7877 10.9133 28.9983 11.4438 29H20.5562C21.0867 28.9983 21.5951 28.7877 21.9713 28.4137L28.4137 21.9713C28.7877 21.5951 28.9983 21.0867 29 20.5562V11.4438C28.9983 10.9133 28.7877 10.4049 28.4137 10.0288ZM15 10C15 9.73478 15.1054 9.48043 15.2929 9.29289C15.4804 9.10536 15.7348 9 16 9C16.2652 9 16.5196 9.10536 16.7071 9.29289C16.8946 9.48043 17 9.73478 17 10V17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18C15.7348 18 15.4804 17.8946 15.2929 17.7071C15.1054 17.5196 15 17.2652 15 17V10ZM16 23C15.7033 23 15.4133 22.912 15.1666 22.7472C14.92 22.5824 14.7277 22.3481 14.6142 22.074C14.5006 21.7999 14.4709 21.4983 14.5288 21.2074C14.5867 20.9164 14.7296 20.6491 14.9393 20.4393C15.1491 20.2296 15.4164 20.0867 15.7074 20.0288C15.9983 19.9709 16.2999 20.0007 16.574 20.1142C16.8481 20.2277 17.0824 20.42 17.2472 20.6666C17.412 20.9133 17.5 21.2033 17.5 21.5C17.5 21.8978 17.342 22.2794 17.0607 22.5607C16.7794 22.842 16.3978 23 16 23Z"
        fill={color}
      />
    </svg>
  );
};

export { ErrorFilledSvg };
